import React from 'react';

import moment from 'moment';

function EventDetail(props) {
  const calendarEvent = props.calendarEvent;

  return (
    <div>
      <div>
        <h3>{calendarEvent.title}</h3>
        <p>{calendarEvent.location}</p>
      </div>
      <div>
        { calendarEvent.allDay ? (
          <p>{moment(calendarEvent.start).format('LL')}</p>
        ) : (
          <div>
            <p>{moment(calendarEvent.start).format('LL')}</p>
            <p>{moment(calendarEvent.start).format('LT')} - {moment(calendarEvent.end).format('LT')}</p>
          </div>
        )}
      </div>
      <div>
        <p>{calendarEvent.description}</p>
      </div>
    </div>
  );
}

export default EventDetail;


// WEBPACK FOOTER //
// ./src/scenes/Planner/components/EventDetail.js